import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import Cookies from "js-cookie";
import i18next from "i18next";

import { ReactComponent as Navi1 } from "./icons/question-icon.svg";
import { ReactComponent as Navi2 } from "./icons/shopping-icon.svg";
import { ReactComponent as Navi3 } from "./icons/home-icon.svg";
import { ReactComponent as Back } from "./icons/back-icon.svg";
import { ReactComponent as Forward } from "./icons/forward-icon.svg";
import { ReactComponent as En } from "./icons/english-icon.svg";
import { ReactComponent as Fr } from "./icons/french-icon.svg";
import { ReactComponent as Es } from "./icons/spanish-icon.svg";
import { ReactComponent as User } from "./icons/user.svg";

import FAQ from "./FAQ/FAQ";
import { languages } from "../../staticData/languages";

function NaviBar(props) {
  const [containerPosition, setContainerPosition] = useState({ x: 0, y: 0 });
  const languageDivRef = useRef(null);

  useEffect(() => {
    if (languageDivRef.current) {
      const rect = languageDivRef.current.getBoundingClientRect();
      setContainerPosition({
        x: rect.left, // x position
        y: rect.bottom, // bottom of the language div
      });
    }
  }, []);

  const history = useNavigate();
  const { cart, setShowCart, langs, setLoading } = props;

  const EURO_FLAG = localStorage.getItem("EURO_FLAG") === "TRUE";
  const machineData = JSON.parse(localStorage.getItem("machine"));
  const faq = machineData?.themeColor?.faq;
  const privacy = machineData?.themeColor?.privacy;
  let machineID = machineData?._id;
  let machineLanguage = machineData?.languages ? machineData?.languages : [];
  const mobile = machineData?.mobile;

  const [currFlag, setCurrFlag] = useState(<En className="navi-icon" />);

  if (machineLanguage) {
    machineLanguage = machineLanguage.map((i) => i.code);
  }

  const [showScanModel, setShowScanModel] = useState(false);

  const lanOptions = languages.filter((item) =>
    machineLanguage.includes(item.code)
  );

  // machineLanguage.forEach((element) => {
  //   const index = languages.findIndex((e) => e.code === element);
  //   if (index > -1) {
  //     lanOptions.push(languages[index]);
  //   }
  // });

  const home = () => {
    const homepage = localStorage.getItem("homepage");
    history(homepage);
  };

  // const forward = () => {
  //   history.goForward();
  // };

  // const goBack = () => {
  //   if (!window.location.href.includes("homePage")) {
  //     history.goBack();
  //   }
  // };

  const [curr, setCurr] = useState([]);
  const [rest, setRest] = useState([]);
  const [show, setShow] = useState(false);
  const [showFAQ, setShowFAQ] = useState(false);

  const setShowTrue = () => {
    show ? setShow(false) : setShow(true);
  };

  const showFAQfunc = () => {
    showFAQ ? setShowFAQ(false) : setShowFAQ(true);
  };

  const clickCart = () => {
    if (cart && cart.length > 0) {
      setShowCart(true);
    }
  };

  // let component = <Forward className="navi-icon" onClick={forward} />;
  //mobile
  // if (mobile) {
  //   component = (
  //     <User className="navi-icon" onClick={() => setShowScanModel(true)} />
  //   );
  // }

  useEffect(() => {
    const currentLan = Cookies.get("i18next") || languages[0].name;
    const findindex = lanOptions.findIndex((e) => e.code === currentLan);

    if (findindex > -1) {
      let currentop = lanOptions[findindex];

      if (currentop?.code === "en") {
        console.log("22");
        setCurrFlag(<En className="navi-icon" />);
      }
      if (currentop?.code === "fr") {
        setCurrFlag(<Fr className="navi-icon" />);
      }
      if (currentop?.code === "es") {
        setCurrFlag(<Es className="navi-icon" />);
      }

      setCurr(currentop);
      const copy = [...lanOptions];

      if (EURO_FLAG) {
        copy.forEach((e) => {
          e.image = e.image2;
        });
      }

      const newRest = copy.splice(findindex, 1);

      setRest(copy);
    }
    // console.log('crr', lanOptions[findindex]);
  }, []);

  const selectLanguage = async (index) => {
    rest.push(curr);
    const newCurr = rest.splice(index, 1);
    if (newCurr[0]?.code === "en") {
      console.log("22");
      setCurrFlag(<En className="navi-icon" />);
    }
    if (newCurr[0]?.code === "fr") {
      setCurrFlag(<Fr className="navi-icon" />);
    }
    if (newCurr[0]?.code === "es") {
      setCurrFlag(<Es className="navi-icon" />);
    }

    setRest([...rest]);
    setCurr(newCurr[0]);
    setShow(false);

    props.setlangs(newCurr[0].code);
    await i18next.changeLanguage(newCurr[0].code);
  };

  const restLanguage = rest.map((e, i) => {
    if (e.code === "en") {
      return (
        <div
          className="langauge-resetLan"
          key={i}
          onClick={() => {
            selectLanguage(i);
          }}
        >
          <En className="navi-icon language-other-icon" />
          <div className="language-other-text">{e.name}</div>
        </div>
      );
    }
    if (e.code === "fr") {
      return (
        <div
          className="langauge-resetLan"
          key={i}
          onClick={() => {
            selectLanguage(i);
          }}
        >
          <Fr className="navi-icon language-other-icon" />
          <div className="language-other-text">{e.name}</div>
        </div>
      );
    }
    if (e.code === "es") {
      return (
        <div
          className="langauge-resetLan"
          key={i}
          onClick={() => {
            selectLanguage(i);
          }}
        >
          <Es className="navi-icon language-other-icon" />
          <div className="language-other-text">{e.name}</div>
        </div>
      );
    }
  });

  // console.log('languages', currFlag);

  return (
    <div className="navi-bar">
      <FAQ show={showFAQ} setShow={setShowFAQ} langs={langs} />
      <div className="language-div" ref={languageDivRef} onClick={setShowTrue}>
        {currFlag}
      </div>
      {show && (
        <div
          className="langauge-resetLan-container"
          style={{
            position: "absolute",
            left: containerPosition.x + 12 + "px",
            top: containerPosition.y + "px", // Add 10px offset if needed
          }}
        >
          {restLanguage}
        </div>
      )}
      {(faq?.length > 0 && faq[0].header?.en) ||
      (privacy?.length > 0 && privacy[0].header?.en) ? (
        <Navi1 className="navi-icon" onClick={showFAQfunc} />
      ) : (
        <div className="empty-icon"></div>
      )}

      <Navi3 className="navi-icon" onClick={home} />
      <div className="home-logo-div">
        <img src={""} className="home-logo" alt=""></img>
      </div>
      {/* <Back className="navi-icon" onClick={goBack} /> */}
      {/* {component} */}
      <Navi2 className="navi-icon" onClick={clickCart} />
      {/* <img src={Navi1} className="navi-icon" alt="" onClick={showFAQfunc}></img> */}
    </div>
  );
}
export default NaviBar;
